import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../../../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";

//Redux
import { useSelector } from "react-redux";
import { InputField } from "../../../../Components/formElements/InputField";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { useReactToPrint } from "react-to-print";
import CashExpensesPrintOut from "../Cash_Expeneses/CashExpensesPrintOut";
const BankStatementDetails = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Sourcing");
  localStorage.setItem("submenu", "Indent");
  const pageStyle = `
  @page {
    size: A4 portrait; /* Sets the paper size to A3, in portrait orientation */
    margin: 10mm;     /* Optional: Sets a small margin for the page */
  }
 
  /* Optional: Targeting the body inside the print document for better fill */
  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
`;
  let bankStatementNr = useSelector(
    (state) => state?.customer?.bankStatement?.bankStatements
  ); // User Details from Store
  const [formInputs, setFormInputs] = useState({});
  const [isCardVisible, setCardVisible] = useState(true);
  // View attachment file
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const [getDisabledStatus, setDisabledStatus] = useState(true);
  const loadFirstLevelData = async (page) => {
    if (bankStatementNr) {
      let obj = {
        documentNumber: bankStatementNr,
      };
      await ItemService.getCustInvoiceDetail(obj).then((item) => {
        // console.log(item);
        if (item?.status === 200) {
          setDisabledStatus(true);
          setFormInputs(item?.data[0]);
          //   setPOLineItemsData(item?.data[0]?.items);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
      navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const firstItem =
    formInputs?.items && formInputs.items.length > 0
      ? formInputs.items[0]
      : null;

  const amountToShow = firstItem
    ? firstItem.debitAmount === 0
      ? firstItem.creditAmount
      : firstItem.creditAmount === 0
      ? firstItem.debitAmount
      : firstItem.creditAmount || firstItem.debitAmount || ""
    : "";

  // Commmon OnChange of the input scetion
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  //print out
  const [printInvoiceData, setPrintInvoiceData] = useState();
  // eslint-disable-next-line
  const [showPrint, setShowPrint] = useState(false);
  // eslint-disable-next-line
  const [getInvoiceChildData, setInvoiceChildData] = useState();

  const printInvoiceDataChild = (childdData) => {
    setInvoiceChildData(childdData);
    // console.log(">>Received childdData from child:", childdData);
    // You can now use this data in the parent component
  };

  useEffect(() => {
    setPrintInvoiceData(formInputs);
  }, [formInputs]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    // content: () => contentRef.current,
    // documentTitle: `Invoice_${invoiceData?.documentNumber}`,
    documentTitle: `Voucher`,
    onAfterPrint: () => setShowPrint(false),
    pageStyle: pageStyle,
  });

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              Bank Statement Details :{" "} 
              {/* <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {bankStatementNr}
              </span> */}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.voucherNumber}
              </span>
            </h2>
            <p className="subText">Bank Statement</p>
            <hr />
            <Row>
              <Col xs={12} md={{span:2,offset:10}} lg={{span:2,offset:10}}className="text-left mb-2">
                {/* <button className="btnBack" onClick={handlePrint}> */}
                <button
                  className="btn btnTable"
                  onClick={() => {
                    setShowPrint(true);
                    setTimeout(handlePrint, 0); // ensure component mounts first
                  }}
                >
                  <i class="bi bi-upload mx-2"></i>
                  Export
                </button>
              </Col>
            </Row>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">IH</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Invoice Header</span>
                      <span className="subHeaderTitle">Invoice Header</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <Row>
                    <Col xs={12} md={12} lg={12}>
                      <div className="accordion-body">
                        <Col xs={12} md={12} lg={12} className="p-2">
                          {/* <p className="mb-0 text-lg">
                              {invoiceData?.companyCodeDesc}
                            </p> */}
                          {/* <p className="mb-0 text-lg">
                              {invoiceData?.companyAddress}
                            </p> */}
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Billing:</p>
                          <p className="text-lg mb-0">
                              {formInputs?.companyCodeDesc}
                            </p>
                           {/*  <p className="text-lg mb-0">
                              {invoiceData?.items
                                ? invoiceData?.items[0]?.customerAddress
                                : ""}
                            </p> */}

                          {/* {invoiceData?.items &&
                          invoiceData.items[0]?.certifications
                            ?.filter((doc) =>
                              Object.keys(documentTypeMap).some((type) =>
                                doc.documentType.includes(type)
                              )
                            )
                            .map((doc, index) => {
                              const title =
                                documentTypeMap[doc.documentType] ||
                                doc.documentType; // Fallback to original if not found

                              return (
                                <p key={index} className="fs-5 mb-0">
                                  <b>{title}: </b> {doc.documentNumber}
                                </p>
                              );
                            })} */}
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          <p className="fw-bold mb-0">Shipping:</p>
                          <p className="text-lg mb-0">
                            {formInputs?.customerCodeDesc}
                          </p>
                          <p className="text-lg mb-0">
                            {/* {invoiceData?.items
                                ? invoiceData?.items[0]?.shippingAddress + " "
                                : ""}
                              {invoiceData?.items
                                ? invoiceData?.items[0]?.shippingPostalCode
                                : ""} */}
                          </p>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-2">
                          {/* <p className="fw-bold mb-0">Godown:</p> */}
                          <p className="text-lg mb-0">
                            {/* {invoiceData?.items
                                ? invoiceData?.items[0]?.godownAddress
                                : ""} */}
                          </p>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BS</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Statement</span>
                      <span className="subHeaderTitle">Bank Statement</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="companyCodeDesc"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.companyCodeDesc || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer/Vendor/Employee"
                          name="customerCode"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.customerCodeDesc || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Date"
                          name="bankTransactionDate"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.bankTransactionDate || formInputs?.postingDate ||""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bank Name"
                          name="bankName"
                          extraLabel=""
                          placeholder=""
                          value={
                            formInputs?.bankName ||
                            formInputs?.customerBankName ||
                            formInputs?.customerBandkDetails
                              ?.bankAccountNumber ||
                            ""
                          }
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transaction Type"
                          name="type"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.type || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Amount"
                          name="amount"
                          value={amountToShow}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                          placeholder="Enter Amount"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Remarks"
                          name="remarks"
                          extraLabel=""
                          placeholder=""
                          value={formInputs?.remarks || ""}
                          onChange={onInputChange}
                          disabled={getDisabledStatus}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div /* style={{ display: "none" }} */ className="d-none">
        <CashExpensesPrintOut
          ref={contentRef}
          data={printInvoiceData}
          onsendinvoicedata={printInvoiceDataChild}
        />
      </div>
       {/* <div className="d-block">
        <CashExpensesPrintOut
          ref={contentRef}
          data={printInvoiceData}
          onsendinvoicedata={printInvoiceDataChild}
        />
      </div> */}
    </main>
  );
};

export default BankStatementDetails;
